import { Breakpoints, Spacing, withTheming, Inset, Shadows, Media } from '@doordash/design-language';
import styled from 'styled-components';
import { ToastPositionAlignment, ToastPosition } from './constants.js';
import { isTopPosition } from './utils.js';

var _templateObject, _templateObject2;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var DESKTOP_SIZE = Breakpoints.Mobile;
var MAX_WIDTH = "calc(100vw - ".concat(Spacing.XxSmall * 2, "px)");
var ToastContainer = styled.div.withConfig({
  displayName: "styles__ToastContainer",
  componentId: "sc-l1f8ls-0"
})(["display:flex;padding:", "px;justify-content:", ";"], function (props) {
  return props.insetFromEdge;
}, function (props) {
  return ToastPositionAlignment[props.position];
});
var ToastContentContainer = withTheming(styled(Inset).attrs(function () {
  return {
    size: Spacing.Large,
    isSquished: true
  };
}).withConfig({
  displayName: "styles__ToastContentContainer",
  componentId: "sc-l1f8ls-1"
})(["background:", ";border-radius:", "px;box-shadow:", ";pointer-events:auto;display:inline-flex;min-height:", "px;max-width:", ";& > *{width:100%;}", ";", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.Colors.ToastInformationalBackground;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.Shape.Toast === 'Pill' ? Spacing.Large * 2 : theme.BorderRadius.ToastContainer;
}, Shadows.Medium, Spacing.XxLarge, MAX_WIDTH, Media.Desktop(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: ", ";\n  "])), function (_ref3) {
  var hasAction = _ref3.hasAction;
  return hasAction ? "".concat(DESKTOP_SIZE, "px") : 'auto';
}), Media.Mobile(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: ", ";\n  "])), function (_ref4) {
  var hasAction = _ref4.hasAction;
  return hasAction ? "".concat(MAX_WIDTH) : 'auto';
})));
var ViewportToastsContainer = styled.div.withConfig({
  displayName: "styles__ViewportToastsContainer",
  componentId: "sc-l1f8ls-2"
})(["position:fixed;width:100vw;pointer-events:none;margin:", ";bottom:", ";left:", ";right:", ";top:", ";"], function (_ref5) {
  var position = _ref5.position;
  return position === ToastPosition.TopCenter || position === ToastPosition.BottomCenter ? 'auto' : undefined;
}, function (_ref6) {
  var position = _ref6.position;
  return !isTopPosition(position) ? 0 : undefined;
}, function (_ref7) {
  var position = _ref7.position;
  return position === ToastPosition.BottomStart || position === ToastPosition.TopStart ? 0 : undefined;
}, function (_ref8) {
  var position = _ref8.position;
  return position === ToastPosition.BottomEnd || position === ToastPosition.TopEnd ? 0 : undefined;
}, function (_ref9) {
  var position = _ref9.position;
  return isTopPosition(position) ? 0 : undefined;
});

export { ToastContainer, ToastContentContainer, ViewportToastsContainer };
